import { Injectable } from '@angular/core';
import { INDRAApiService } from '@ibe.services/api.indra.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { 	MOCK_STATUS,
	URL_BFM_PNRS_SEARCH,
	MOCK_URL_BFM_BOOKED_TRIPS_LIST,
	MOCK_URL_BFM_BOOKED_TRIP_SEARCH,
	URL_BFM_PNRS_LIST
} from '@ibe.config';
import { INDRABookingList } from '@ibe.models/booked-trips.indra.model.lib';
import { INDRAPnrDetailsServiceResponse } from '@ibe.models/booked-trip-details.indra.model.lib';

@Injectable({
  providedIn: 'root'
})
export class INDRARetrievePnrService {

	constructor(private api: INDRAApiService, private http: HttpClient) {
    }

	public INDRA_getPNRList(tapID: string): Observable<INDRABookingList> {
		let RETRIEVE_BOOKING_LIST = URL_BFM_PNRS_LIST + '?email=xxx&status=All&tapID=';
		if (MOCK_STATUS.BOOKING_LIST) {
			return this.http.get<INDRABookingList>(MOCK_URL_BFM_BOOKED_TRIPS_LIST);
		} else {
			return this.api.INDRA_get<INDRABookingList>(RETRIEVE_BOOKING_LIST + tapID);
		}
	}

	public INDRA_getPNRListByStatus(status:string): Observable<INDRABookingList> {
		let RETRIEVE_BOOKING_LIST = URL_BFM_PNRS_LIST + '?status=' + status;
		if (MOCK_STATUS.BOOKING_LIST) {
			return this.http.get<INDRABookingList>(MOCK_URL_BFM_BOOKED_TRIPS_LIST);
		} else {
			return this.api.INDRA_get<INDRABookingList>(RETRIEVE_BOOKING_LIST);
		}

	}

	//TODO Update the model for observable.
	public INDRA_searchPNR(documentNumber: string, lastname: string): Observable<INDRAPnrDetailsServiceResponse> {
		if (MOCK_STATUS.BOOKING_SEARCH) {
			return this.http.get<INDRAPnrDetailsServiceResponse>(MOCK_URL_BFM_BOOKED_TRIP_SEARCH);
		} else {
			const data = {
				"lastName": lastname
				};

			if (documentNumber.length === 6) {
				data['pnrNumber'] = documentNumber;
			} else {
				data['ticketNumber'] = documentNumber;
			}

			return this.api.INDRA_post<INDRAPnrDetailsServiceResponse>(`${URL_BFM_PNRS_SEARCH}?skipAncillariesCatalogue=true`, data);
		}
	}
}
